<script>
    import {
        useForm,
        validators,
        HintGroup,
        Hint,
        email,
        required,
    } from "svelte-use-form";
    import {
        GoogleAuthProvider,
        signInWithEmailAndPassword,
        signInWithPopup,
    } from "firebase/auth";
    import { userLoggedIn } from "../Stores";
    import { redirectToHome } from "../Utils";
    import { wrongPassword, userNotFound } from "./errorCodes";
    import { saveUserToFirestore } from "./externalCommunications";

    export let auth;
    export let firestore;

    const googleProvider = new GoogleAuthProvider();

    const form = useForm();

    let serverError;

    async function handleSubmit(event) {
        event.preventDefault();
        try {
            serverError = undefined;
            await signInWithEmailAndPassword(
                auth,
                $form.email._value,
                $form.password._value,
            );

            $userLoggedIn = true;

            await saveUserToFirestore(firestore, auth.currentUser);

            redirectToHome();
        } catch (error) {
            serverError = error;
            return false;
        } finally {
            if ($userLoggedIn) {
                console.log(auth.currentUser.uid);
            }
        }
    }
</script>

<div id="login-div">
    <div id="login-frame" cy_data="login-frame">
        <h1>Iniciar sessão</h1>
        <form use:form>
            <label for="email">Email</label>
            <input
                type="email"
                name="email"
                cy_data="email-login"
                use:validators={[required, email]}
            />
            <HintGroup for="email">
                <Hint on="required"><p class="hint">Campo obrigatório</p></Hint>
                <Hint on="email" hideWhenRequired
                    ><p class="hint">Email inválido</p></Hint
                >
            </HintGroup>
            <label for="password">Palavra passe</label>
            <input
                type="password"
                name="password"
                cy_data="password-login"
                use:validators={[required]}
            />
            <Hint for="password" on="required"
                ><p class="hint">Campo obrigatório</p></Hint
            >
            <div id="button-div">
                <button
                    disabled={!$form.valid}
                    on:click={handleSubmit}
                    cy_data="login-button"
                >
                    Login
                </button>
            </div>
        </form>

        <div id="error">
            {#if typeof serverError !== "undefined"}
                {#if serverError.code === wrongPassword}
                    <p cy_data="wrong-password">Palavra passe errada 🙅‍♂️</p>
                {:else if serverError.code === userNotFound}
                    <p cy_data="user-not-found">
                        Não existe nenhuma conta associada a este email 🤷‍♂️
                    </p>
                {:else}
                    <p>
                        Ocorreu um erro desconhecido! Volta a tentar mais tarde
                        🙏
                    </p>
                {/if}
            {/if}
        </div>

        <p>
            Esqueceste-te da palavra passe?
            <a href="/recover-password"> Recupera-a </a>
        </p>

        <p id="oAuth-title">Ou inicia sessão com:</p>
        <div id="button-div">
            <button
                id="oAuthButton"
                on:click={async () => {
                    await signInWithPopup(auth, googleProvider);
                    await saveUserToFirestore(firestore, auth.currentUser);
                    redirectToHome();
                }}
            >
                <img
                    src="./images/oAuth/google-logo.png"
                    loading="lazy"
                    alt="google logo"
                    width="20"
                    id="google"
                /> a tua conta google
            </button>
        </div>

        <p>
            Ainda não tens conta?
            <a id="register" href="/register" cy_data="register">
                Regista-te!
            </a>
        </p>
    </div>
</div>

<!-- <pre>
{JSON.stringify($form, null, " ")}
</pre> -->

<style>
    #login-div {
        display: flex;
        flex-direction: column;
        place-items: center;
        text-align: center;
    }

    #login-frame {
        width: fit-content;
        max-width: min-content;

        margin-top: 2rem;
        margin-bottom: 2rem;

        padding: 2rem;
        padding-left: 3rem;
        padding-right: 3rem;

        border-style: solid;
        border-width: 3px;
        border-color: #164e63;
        border-radius: 0.375rem;
    }

    h1 {
        margin-bottom: 1rem;
        font-size: large;
        font-weight: 600;
    }

    form {
        display: flex;
        flex-direction: column;
        place-items: start;
        text-align: start;
    }

    #button-div {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    button {
        display: flex;
        color: #f1f5f9;
        background-color: #164e63;

        width: fit-content;

        border-radius: 0.375rem;

        margin-top: 1rem;
        margin-bottom: 1rem;

        padding-left: 0.5rem;
        padding-right: 0.5rem;
        padding-top: 0.25rem;
        padding-bottom: 0.4rem;
    }

    #oAuthButton {
        margin-top: 0.5rem;
    }

    button:disabled {
        background-color: #445e77;
        cursor: not-allowed;
    }

    button:hover {
        color: #d4d4d4;
    }

    button:active {
        background-color: #155e75;
    }

    .hint {
        font-size: small;
    }

    input {
        border-color: transparent;
        border-width: 2px;
        border-radius: 0.375rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    img {
        padding-top: 0.15rem;
        margin-right: 0.25rem;
    }

    a {
        color: #164e63;
    }

    a:hover {
        color: #155e75;
    }

    #oAuth-title {
        margin-top: 1rem;
    }

    #error {
        color: red;
        margin-bottom: 0.75rem;
    }

    :global(.touched:invalid) {
        border-color: red;
        outline-color: red;
    }
</style>
